import {HeaderLayoutConfig} from "ict24h-themes-react/lib/esm/components/UI/Header/Header";

export const configPortalLayout: HeaderLayoutConfig = {
	appName: "Quản Lý Phê Duyệt",
	logoLink: "https://ict24h.net",
	backgroundColor: "#454791",
	color: "#000",
};